import React from "react";
import { Flex, NumberInput, ActionIcon, Chip } from "@mantine/core";
import { CustomSelect } from "@components/custom";
import { useMediaQuery } from "@mantine/hooks";

export const CustomConditionalRow = () => {
  const isMobile = useMediaQuery("(max-width: 75em)"); // Using theme lg breakpoint

  return (
    <Flex gap="sm" align="start" direction={{ base: "column", lg: "row" }}>
      <Chip
        variant="sky"
        size="lg"
        checked
        styles={{
          label: {
            padding: "0 1em",
          },
        }}
      >
        IF
      </Chip>

      {isMobile ? (
        // Mobile: Source and metric on same row, then type/threshold/delete row
        <>
          <Flex gap="sm" align="center" w="100%">
            <CustomSelect
              placeholder="Select source"
              data={[
                { value: "insiders", label: "Insiders" },
                { value: "rtrt", label: "RTRT" },
                { value: "race-ranges", label: "Race Rangers" },
              ]}
              style={{ flex: 1 }}
            />
            <CustomSelect
              placeholder="Select metric"
              data={[
                { value: "hr", label: "Heart Rate" },
                { value: "power", label: "Power" },
                { value: "speed", label: "Speed" },
              ]}
              style={{ flex: 1 }}
            />
          </Flex>
          <Flex gap="sm" align="center">
            <CustomSelect
              w={100}
              placeholder="Select"
              variant="sky"
              data={[
                { value: "=", label: "=" },
                { value: ">", label: ">" },
                { value: "<", label: "<" },
              ]}
            />
            <NumberInput
              placeholder="Enter value"
              min={0}
              style={{ flex: 1 }}
            />
            <ActionIcon variant="light" size="xs">
              <></>
            </ActionIcon>
          </Flex>
        </>
      ) : (
        // Desktop: Original horizontal layout
        <>
          <CustomSelect
            placeholder="Select source"
            data={[
              { value: "insiders", label: "Insiders" },
              { value: "rtrt", label: "RTRT" },
              { value: "race-ranges", label: "Race Rangers" },
            ]}
          />
          <CustomSelect
            placeholder="Select metric"
            data={[
              { value: "hr", label: "Heart Rate" },
              { value: "power", label: "Power" },
              { value: "speed", label: "Speed" },
            ]}
          />
          <CustomSelect
            w={100}
            placeholder="Select"
            variant="sky"
            data={[
              { value: "=", label: "=" },
              { value: ">", label: ">" },
              { value: "<", label: "<" },
            ]}
          />
          <NumberInput placeholder="Enter value" min={0} />
          <ActionIcon variant="light" size="xs">
            <></>
          </ActionIcon>
        </>
      )}
    </Flex>
  );
};
